import React, { useState, useEffect } from "react";
import { fetchBitcoinPrice, fetchRecommendedFees } from "../api/Bitcoin";

function BitcoinInfo() {
	const [price, setPrice] = useState(null);
	const [fees, setFees] = useState(null);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(true); // Track loading state

	useEffect(() => {
		async function loadBitcoinData() {
			try {
				setLoading(true); // Start loading
				const priceData = await fetchBitcoinPrice();
				setPrice(priceData);

				const feeData = await fetchRecommendedFees();
				setFees(feeData);
			} catch (err) {
				setError("Failed to fetch data: " + err.message); // Handle errors
			} finally {
				setLoading(false); // Stop loading
			}
		}

		loadBitcoinData();
	}, []);

	if (loading) {
		return <div>Loading...</div>; // Show loading indicator
	}

	if (error) {
		return <div>Error: {error}</div>; // Display error if any
	}

	return (
		<div>
			<h1>Bitcoin Info</h1>
			{price && <div>Price: {price.prices.USD} USD</div>}
			{fees && (
				<div>
					<p>Fastest Fee: {fees.fastestFee}</p>
					<p>Economy Fee: {fees.economyFee}</p>
				</div>
			)}
		</div>
	);
}

export default BitcoinInfo;
